export default "__VITE_ASSET__CiNMg24M__"